import React from 'react';
import { token } from '@atlaskit/tokens';

type Props = {
	x: number;
	y: number;
	children: string;
};

export const ProjectStyleText = ({ x, y, children }: Props) => (
	<text
		fontSize="12"
		x={`${x}`}
		y={`${y}`}
		textAnchor="middle"
		fill={token('color.text.subtlest', '#6B778C')}
	>
		{children}
	</text>
);
